import { connect } from 'react-redux';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
});

export default SuccessActions => connect(mapStateToProps, null)(SuccessActions);
